import React from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import DownloadAppBtn from "./DownloadAppBtn";

const TIME_FORMAT = "LT";

class AppointmentECheckinDashboardMessage extends React.Component {    
    render() {
        const {visitDateTime, SDCVisitEnabledMinutesAfterStart, enableEcheckinMandatoryUpdates} = this.props;
        const isMobile = Tools.isMobile();
        const visitTimeAfter = Tools.addMinutesToDate(visitDateTime, SDCVisitEnabledMinutesAfterStart);
        const closingTime = Tools.formatCentralDate(visitTimeAfter, TIME_FORMAT);        

        return (
        <React.Fragment> 
            {enableEcheckinMandatoryUpdates ?
                <p>
                    <strong>Once eCheck-in is complete</strong><br />
                    Launch your visit from the home screen. Room entry closes at {`${closingTime}`}. 
                    For the best results, 
                    {isMobile ?
                            <React.Fragment>&nbsp;<DownloadAppBtn type="link" label="download MyBSWHealth app" logPrefix={"MBHWeb.UI.VideoVisitConfirmationStatus"} />.</React.Fragment>
                            : <React.Fragment> use <span className="visit-on-chrome"><a href="https://www.google.com/chrome/" target="_blank">Chrome</a></span> as your browser.</React.Fragment>
                    }
                </p> :
                <React.Fragment>

                <p>
                    <strong>Before your appointment</strong><br />
                    <span className="sdc-text">From the home screen, be sure to eCheck-in before your visit.</span>
                </p>
                <img alt="Dashboard Appointment Tile" src="/images/appt-echeckin-tile.png" className="img-fluid" />            
                <p>
                    <strong>On the day of your appointment</strong><br />
                    <span className="sdc-text">Once eCheck-in has been completed, start your Video Visit using the "LAUNCH VIDEO VISIT" button on the home screen. For the best results,
                        {isMobile ?
                            <React.Fragment>&nbsp;<DownloadAppBtn type="link" label="download MyBSWHealth app" logPrefix={"MBHWeb.UI.VideoVisitConfirmationStatus"} />.</React.Fragment>
                            : <React.Fragment> use <span className="visit-on-chrome"><a href="https://www.google.com/chrome/" target="_blank">Chrome</a></span> as your browser.</React.Fragment>
                        }
                    </span>
                </p>
            </React.Fragment>
            }            
            {enableEcheckinMandatoryUpdates && <img alt="Dashboard Appointment Tile" src="/images/appt-echeckin-tile.png" className="img-fluid appt-echeckin-tile" />}
            <img alt="Dashboard Appointment Tile" src="/images/appt-echeckin-complete-tile.png" className="img-fluid" />
        </React.Fragment>);

    }
}

const mapStateToProps = (state) => {
    return {
        SDCVisitEnabledMinutesAfterStart: state.session.serverData && state.session.serverData.SDCVisitEnabledMinutesAfterStart ? state.session.serverData.SDCVisitEnabledMinutesAfterStart : "10",
        hasMyChart: state.domain.hm,
        enableEcheckinMandatoryUpdates: state.session.serverData && state.session.serverData.enableEcheckinMandatoryUpdates ? state.session.serverData.enableEcheckinMandatoryUpdates : false
    }
};
export default connect(mapStateToProps, null)(AppointmentECheckinDashboardMessage);